const styles = theme => ({
  root: {
    textAlign: 'center',
    alignItems: 'center',
    zIndex: 5,
    width:'50%',
    position: 'absolute',
    marginLeft: '25%',
    marginTop: '-50%',
    color: 'white',
    [theme.breakpoints.up('sm')]: {
      marginTop: '-30%',
      width:'30%',
      marginLeft: '35%',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '-18%',
      width:'20%',
      marginLeft: '40%',
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/GetStarted/components/DescriptionText/styles.js